var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('html-content',{attrs:{"api":"https://api.prohealthfactor.ru/api/v1/htm/app/service/page/link/confidence"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }